import fetchData from '../lib/fetch';

export default {
  async fetch() {
    // Fetch data from specified url
    const data = await fetchData('./data/metric-P100D.json');
    return data;
  },
};
